<template>
  <div>
    <Metadata :description="page.description" :image="page.image"></Metadata>
    <Nav :links="links"></Nav>
    <Hero class="mb-10">
      <SkillSearch></SkillSearch>
    </Hero>
    <div v-for="category in categories" :title="category" :headline="category">
      <h1
        class="m-4 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-3xl lg:text-4xl dark:text-white"
      >
        {{ category.name }}
      </h1>

      <div
        :id="`${category}-skills`"
        class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-4"
      >
        <ListedSkill
          v-for="skill in category.skills"
          class="m-4"
          :key="skill._id"
          :skill="skill"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ListedSkill from "~/components/ListedSkill.vue";
import { useSkillStore } from "../store";
const store = useSkillStore();
const categories = computed(() => store.getCategories);

const links = [];

const page = {
  description:
    "A curated library of technical and non-technical skills for software developers.",
  image:
    "https://assets.cdn.filesafe.space/6tz26cRo5Do2KAZ8v8yp/media/65a94d4c28a68b89dbbfa360.png",
};

</script>

<style scoped>
/* CSS specific to this page */
</style>
